/*
 * @Author: wuhao
 * @Date: 2020-04-08 14:28:17
 * @LastEditors: wuhao
 * @LastEditTime: 2020-04-08 15:23:40
 * @Description: 封装table搜索条件
 */

import ApexFilter from './src/index'

ApexFilter.install = function(Vue) {
  Vue.component(ApexFilter.name, ApexFilter)
}

export default ApexFilter
